import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6d643b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "自動振り分けスタッフ設定", -1))
const _hoisted_3 = { class: "flex flex-column" }
const _hoisted_4 = {
  key: 0,
  class: "pt-3 flex flex-column align-items-center"
}
const _hoisted_5 = { class: "flex align-items-center cursor-pointer" }
const _hoisted_6 = { class: "step-index absolute left-50 top-50" }
const _hoisted_7 = {
  key: 0,
  class: "staff-priority-component m-3 mb-1 flex align-items-center flex-column"
}
const _hoisted_8 = { class: "w-11 mt-3" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick", "disabled"]

import { get, set } from "@vueuse/core";
import { ref, inject, onBeforeMount, computed } from "vue";
import { StaffPrioritiesServices } from "@/clinic/services";
import { IStaff } from "@/clinic/typings";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import StaffList from "./components/StaffList.vue";
import StaffOrder from "./components/StaffOrder.vue";
import Confirm from "./components/Confirm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const toast = useToast();
const confirm = useConfirm();

const clinicId = ref(0);
const staffList = ref<IStaff[]>();
const distributedStaffs = ref<IStaff[]>();
const autoDistributionIds = ref<number[]>([]);

const setDistributedStaffs = () => {
  const staffs = get(staffList)?.filter((staff: IStaff) => get(autoDistributionIds).includes(staff.id));
  set(distributedStaffs, staffs);
};

const isDistributing = ref(false);
const currentStep = ref(1);
const showComponent = ref({
  list: true,
  order: false,
  confirm: false,
});

const toggleDistribution = () => {
  fetchStaffs();
  set(isDistributing, !get(isDistributing));
  assignDistributedIds();
  set(currentStep, 1);
  set(showComponent, {
    list: true,
    order: false,
    confirm: false,
  });
};
const toggleComponent = async (step: number, status: boolean) => {
  if (step == 1) {
    get(showComponent).list = status;
    if (status) {
      await fetchStaffs();
      assignDistributedIds("update");
    }
  } else if (step == 2) {
    setDistributedStaffs();
    get(showComponent).order = status;
  } else if (step == 3) get(showComponent).confirm = status;
};
const showNextButton = (step: number) => {
  if (step == 1) return get(autoDistributionIds).length > 0;
  if (step == 2) return true;
  return false;
};
const showBackButton = (step: number) => {
  if (step == 1) return false;
  if (step == 2 || step == 3) return true;
  return false;
};
const onClickBackOrNext = (step: number) => {
  toggleComponent(get(currentStep), false);
  set(currentStep, step);
};
const isComponentShown = (step: number) => {
  if (step == 1) return get(showComponent).list;
  if (step == 2) return get(showComponent).order;
  if (step == 3) return get(showComponent).confirm;
  return false;
};

const assignDistributedIds = (status = "init") => {
  const staffIds = get(staffList)
    ?.filter((staff: IStaff) => {
      if (status == "init") {
        return staff.auto_distribution;
      }
      if (status == "update") {
        return get(autoDistributionIds).includes(staff.id);
      }
    })
    .map((staff: IStaff) => staff.id);

  set(autoDistributionIds, staffIds);
  setDistributedStaffs();
};
const updateDistributedStaffs = (staffIds: number[]) => {
  set(autoDistributionIds, staffIds);
};
const orderDistributedStaffs = () => {
  const indexMap = new Map(get(autoDistributionIds).map((id, index) => [id, index]));
  let staffs = get(staffList);
  staffs = staffs?.sort((leftStaff: IStaff, rightStaff: IStaff) => {
    let left = indexMap.get(leftStaff.id) || 0;
    let right = indexMap.get(rightStaff.id) || 0;

    return left - right;
  });

  staffs?.forEach((staff: IStaff, index: number) => {
    staff.priority = index + 1;
  });

  set(staffList, staffs);
};

const items = ref([
  {
    step: 1,
    title: "スタッフを選択",
    component: StaffList,
    props: { staffs: staffList, autoDistributionIds: autoDistributionIds },
    emits: { updateDistributedStaffs: updateDistributedStaffs },
    showBackButton: false,
  },
  {
    step: 2,
    title: "スタッフの優先順位を選択",
    component: StaffOrder,
    props: { staffs: distributedStaffs },
    emits: { "update-distributed-staffs": updateDistributedStaffs, "order-distributed-staffs": orderDistributedStaffs },
    showBackButton: true,
  },
  {
    step: 3,
    title: "最終確認",
    component: Confirm,
    props: { staffs: distributedStaffs, minHeight: "50vh" },
    showBackButton: true,
  },
]);

const fetchStaffs = async () => {
  const { data } = await StaffPrioritiesServices.getList({ clinic_id: get(await get(clinicId)) });
  const staffs = get(data) as unknown as IStaff[];
  set(staffList, staffs);
};

const submit = async () => {
  confirm.require({
    message: "自動振り分け設定を保存します。よろしいですか？",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    accept: async () => {
      const { data: staffs } = await StaffPrioritiesServices.updateList(
        {
          clinic_id: get(await get(clinicId)),
          staff_ids: get(autoDistributionIds),
        },
        () => notifySuccessMsg(toast, "保存しました"),
        () => notityErrorMsg(toast, "保存に失敗しました")
      );
      set(staffList, staffs.value as unknown as IStaff[]);
      set(isDistributing, !get(isDistributing));
      assignDistributedIds();
    },
  });
};

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
  await fetchStaffs();
  assignDistributedIds();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (!isDistributing.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(Confirm, {
                staffs: distributedStaffs.value,
                minHeight: "65vh"
              }, null, 8, ["staffs"]),
              _createElementVNode("button", {
                class: "orange-step-button h-2rem color-white border-none border-round-sm px-2 cursor-pointer mt-3",
                style: {"width":"200px"},
                onClick: toggleDistribution
              }, " 編集する ")
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(items.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.step,
                class: "py-1"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
              'step-component w-2rem h-2rem border-circle relative',
              { orange: currentStep.value == item.step, 'orange-border': currentStep.value == item.step },
            ])
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.step), 1)
                  ], 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(['ml-2', { orange: currentStep.value == item.step }])
                  }, _toDisplayString(item.title), 3)
                ]),
                _createVNode(_Transition, {
                  name: "shrink-effect",
                  mode: "out-in",
                  onAfterLeave: _cache[0] || (_cache[0] = ($event: any) => (toggleComponent(currentStep.value, true)))
                }, {
                  default: _withCtx(() => [
                    (isComponentShown(item.step))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps(item.props, _toHandlers(item.emits)), null, 16)),
                          _createElementVNode("div", _hoisted_8, [
                            (showBackButton(item.step))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "white-step-button color-back bg-white h-2rem color-white border-none border-round-sm px-2 cursor-pointer mr-2",
                                  onClick: ($event: any) => (onClickBackOrNext(item.step - 1))
                                }, " 前のステップ ", 8, _hoisted_9))
                              : _createCommentVNode("", true),
                            (item.step == 1)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "white-step-button color-back bg-white h-2rem color-white border-none border-round-sm px-2 cursor-pointer mr-2",
                                  onClick: toggleDistribution
                                }, " 保存する "))
                              : _createCommentVNode("", true),
                            (item.step != 3)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 2,
                                  class: "orange-step-button h-2rem color-white border-none border-round-sm px-2 cursor-pointer",
                                  onClick: ($event: any) => (onClickBackOrNext(item.step + 1)),
                                  disabled: !showNextButton(item.step)
                                }, " 次のステップ ", 8, _hoisted_10))
                              : _createCommentVNode("", true),
                            (item.step == 3)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 3,
                                  class: "orange-step-button h-2rem color-white border-none border-round-sm px-2 cursor-pointer",
                                  onClick: submit
                                }, " 保存する "))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})